import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PlantRatesLayer from "../components/PlantRatesLayer";

const PlantRatesPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Plant Rates">
        <PlantRatesLayer />
      </MasterLayout>
    </>
  );
};

export default PlantRatesPage;
